import React from 'react';

import { SidePage } from '@gogame/components';

import { useLoadChats } from 'scenes/AIChatbot/data';
import { useIsUpdating } from 'scenes/AIChatbot/data/useIsUpdating';
import { ChatList } from './ChatList';

export const LEFT_DRAWER_Z_INDEX = 1070;

const HistorySidePage = ({
  currentChatId,
  onClose,
  open,
  onExited,
  onSelectChat,
}) => {
  const { isLoading, isRefetching, data } = useLoadChats();
  const isUpdating = useIsUpdating();

  const handleSelectChat = (id) => {
    onSelectChat(id);
    onClose();
  };

  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading}
      fetching={isRefetching || isUpdating}
      size={'sm'}
      backdrop={false}
      zIndex={LEFT_DRAWER_Z_INDEX}
    >
      <SidePage.Title onClose={onClose} title={'History'} />
      <SidePage.Content disableGutters={true} disableScroll={true}>
        <ChatList
          currentChatId={currentChatId}
          data={data}
          onSelectChat={handleSelectChat}
        />
      </SidePage.Content>
    </SidePage>
  );
};

export default HistorySidePage;
